module.exports = __webpack_public_path__ + "static/media/12583876_992520974154243_94557385_n.669b67e6.jpg";